import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";

import Description from "../../Components/Description?v=0.0.2";
import TextFieldWithIcon from "../../Components/TextFieldWithIcon?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";
import * as Constants from "../../Constants?v=0.0.2";
import PreparingSignUpCarosel from "../../Components/PreparingSignUpCarosel?v=0.0.2";

import BusinessDetailsPageImage from "../../Images/BusinessDetailsPageImage.svg";
import Rocket from "../../Images/Rocket.svg";
import BackArrow from "../../Images/BackArrow.svg";
import PreparingImage from "../../Images/PreparingImage.gif";

function BusinessDetailsWiz(props) {
  document.title = "myBooks | Sign Up";
  const industry_options = Constants.industryTypes.map((industry, index) => ({
    key: industry.industry_nm,
    text: industry.industry_nm,
    value: industry.industry_nm,
  }));

  const currency_options = Constants.currencyData.map((currency, index) => ({
    key: currency.currency_code,
    text: currency.currency_code,
    value: currency.currency_code,
  }));

  const fiscal_year_options = Constants.fiscalYearData.map(
    (fiscalYear, index) => ({
      key: fiscalYear.fiscalYear_nm,
      text: fiscalYear.fiscalYear_nm,
      value: fiscalYear.fiscalYear_nm,
    })
  );

  const country_options = Constants.countryData.map((country, index) => ({
    key: country.country_nm,
    text: country.country_nm,
    value: country.country_nm,
  }));

  const environment = props.environment;

  const [step, setStep] = useState(1);

  const [businessName, setBusinessName] = useState(
    props.Organization.companyname
  );
  const [showBusinessNameLabel, setShowBusinessNameLabel] = useState(false);

  const [businessType, setBusinessType] = useState(
    props.Organization.industryType
  );
  const [showBusinessTypeLabel, setShowBusinessTypeLabel] = useState(false);
  const [currency, setCurrency] = useState(props.Organization.currencyId);
  const [showCurrencyLabel, setShowCurrencyLabel] = useState(false);
  const [financialYear, setFinancialYear] = useState(
    props.Organization.fiscalYear
  );
  const [showFinancialYearLabel, setShowFinancialYearLabel] = useState(false);
  const [country, setCountry] = useState(props.Organization.country_txt);
  const [showCountryLabel, setShowCountryLabel] = useState(false);
  const [dateFormat, setDateFormat] = useState(props.Organization.dateFormat);
  const [showAllTextFields, setShowAllTextFields] = useState(false);
  const [animateSignUpStep, setAnimateSignUpStep] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (props.showLoader) {
      setStep(2);
      setTimeout(() => {
        setAnimateSignUpStep(true);
      }, 4000);
    }
    if (props.failMessage !== "") {
      setStep(1);
    }
  }, [step, props]);

  useEffect(() => {
    if (props.signUpSuccess && animateSignUpStep) {
      props.redirect("");
    }
  }, [step, props, animateSignUpStep]);

  useEffect(() => {
    if (props.Organization.country_txt === "") {
      setShowAllTextFields(true);
    }
  }, [props.Organization.country_txt]);

  const prevButtonHandler = useCallback(
    (event) => {
      if (step === 1) {
        let offset = new Date().getTimezoneOffset(),
          o = Math.abs(offset);
        let timezoneValue =
          "GMT" +
          (offset < 0 ? "+" : "-") +
          ("00" + Math.floor(o / 60)).slice(-2) +
          ":" +
          ("00" + (o % 60)).slice(-2);
        let symbol = Constants.currencyData.filter(
          (c) => c.currency_code === currency
        );
        props.clearFailMessage();
        props.onPrev();
        props.SetOrganisationData({
          Organization: {
            timeZone: timezoneValue,
            baseCountry: country === "India" ? "IN" : "USA",
            country_txt: country,
            fiscalYear: financialYear,
            currencyId: currency,
            dateFormat: dateFormat,
            companyname: businessName,
            orgPhoneNumber: "",
            industryType: businessType,
            legalName: businessName,
            multiOrganizationFlag: false,
            curr_sym: HTMLEncode(
              symbol.length > 0 ? symbol[0].currency_symbol : ""
            ),
            device_type: "web app",
            subscriptionType: "Premium",
            source_page:
              country === "India"
                ? environment.indmyBooksAppUrl
                : environment.globalmyBooksAppUrl,
          },
        });
      } else {
        setStep((prevState) => {
          return prevState - 1;
        });
      }
    },
    [
      businessName,
      businessType,
      country,
      currency,
      dateFormat,
      environment.globalmyBooksAppUrl,
      environment.indmyBooksAppUrl,
      financialYear,
      props,
      step,
    ]
  );

  useEffect(() => {
    return history.listen((location) => {
      if (history.action === "POP") {
        prevButtonHandler();
      }
    });
  }, [history, prevButtonHandler]);

  const businessNameChangeHandler = (name) => {
    setBusinessName(name);
    setShowBusinessNameLabel(false);
  };

  const onSelectBusinessTypeDropDownHandler = (event, { value }) => {
    setShowBusinessTypeLabel(false);
    setBusinessType(value);
  };

  const onSelectCurrencyDropDownHandler = (event, { value }) => {
    setShowCurrencyLabel(false);
    setCurrency(value);
  };

  const onSelectFinancialYearDropDownHandler = (event, { value }) => {
    setShowFinancialYearLabel(false);
    setFinancialYear(value);
  };

  const onSelectCountryDropDownHandler = (event, { value }) => {
    setShowCountryLabel(false);
    setCountry(value);
    if (value === "India") {
      setCurrency("INR-India Rupee");
      setFinancialYear("April-March");
      setDateFormat("dd-MM-yyyy");
    } else if (value === "United States Of America (USA)") {
      setCurrency("USD-United States Dollar");
      setFinancialYear("January-December");
      setDateFormat("MM-dd-yyyy");
    } else {
      setCurrency(
        Constants.currencyData.filter((currency) => {
          return currency.currency_country === value;
        })[0].currency_code
      );
      setFinancialYear("January-December");
      setDateFormat("MM-dd-yyyy");
    }
  };

  const ContinueToStep2 = (event) => {
    if (step === 1) {
      if (businessName === "") {
        setShowBusinessNameLabel(true);
      }
      if (businessType === "") {
        setShowBusinessTypeLabel(true);
      }
      if (currency === "") {
        setShowCurrencyLabel(true);
      }
      if (financialYear === "") {
        setShowFinancialYearLabel(true);
      }
      if (country === "") {
        setShowCountryLabel(true);
      }
      if (
        businessName !== "" &&
        businessType !== "" &&
        currency !== "" &&
        financialYear !== "" &&
        country !== ""
      ) {
        let offset = new Date().getTimezoneOffset(),
          o = Math.abs(offset);
        let timezoneValue =
          "GMT" +
          (offset < 0 ? "+" : "-") +
          ("00" + Math.floor(o / 60)).slice(-2) +
          ":" +
          ("00" + (o % 60)).slice(-2);
        props.onDone({
          Organization: {
            timeZone: timezoneValue,
            baseCountry: country === "India" ? "IN" : "USA",
            country_txt: country,
            fiscalYear: financialYear,
            currencyId: currency,
            dateFormat: dateFormat,
            companyname: businessName,
            orgPhoneNumber: "",
            industryType: businessType,
            legalName: businessName,
            multiOrganizationFlag: false,
            curr_sym: HTMLEncode(
              Constants.currencyData.filter(
                (c) => c.currency_code === currency
              )[0].currency_symbol
            ),
            device_type: "web app",
            subscriptionType: "Premium",
            source_page:
              country === "India"
                ? environment.indmyBooksAppUrl
                : environment.globalmyBooksAppUrl,
          },
        });
      }
    }
  };

  const HTMLEncode = (str) => {
    if (str === undefined) {
      return "";
    } else {
      var i = str.length,
        aRet = [];

      while (i--) {
        var iC = str[i].charCodeAt();
        if (iC < 65 || iC > 127 || (iC > 90 && iC < 97)) {
          aRet[i] = "&#" + iC + ";";
        } else {
          aRet[i] = str[i];
        }
      }
      return aRet.join("");
    }
  };

  return (
    <div className="App col-12 d-flex align-items-center myBooks">
      <div className="container custom-container">
        <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
          <div className="col-lg-7  d-none d-lg-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-column margin-interaction-card">
              {step === 1 && (
                <>
                  <div
                    className="d-grid align-items-center justify-content-between"
                    style={{ gridTemplateColumns: "auto 86px" }}
                  >
                    <div
                      className="d-grid align-items-center"
                      style={{ gridTemplateColumns: " 40px auto" }}
                    >
                      <button
                        className="clean-button px-2"
                        onClick={prevButtonHandler}
                      >
                        <img src={BackArrow} alt=""></img>
                      </button>
                      <div>
                        <div className="font-20-600 text-align-left">
                          Few more details before launch
                        </div>
                        <Description
                          className="description text-align-left"
                          text="We want to make sure you get the best of myBooks. We need these few details to customize myBooks to your need"
                        ></Description>
                      </div>
                    </div>
                    <img src={Rocket} alt="" className="mx-2" />
                  </div>
                  <img
                    src={BusinessDetailsPageImage}
                    alt=""
                    className="business-wiz-image mt-3"
                  />
                </>
              )}
              {step === 2 && (
                <>
                  <div className="font-20-600">
                    {"Customizing myBooks for " + businessType + " ..."}
                  </div>
                  <img
                    src={PreparingImage}
                    alt=""
                    className="preparing-gif my-2"
                  />
                  <PreparingSignUpCarosel
                    data={[
                      "You can invite multiple users to your myBooks business accounts and provide specific access",
                      "You can upload your previous data like customer, items and transactions through excel upload also",
                      "You can customize your print templates for invoices & estimates",
                    ]}
                  />
                </>
              )}
              <div className="padding-top d-block">
                <HighlightText
                  className="grey text-align-left font-12-400 center-on-medium-devices"
                  subClassName="blue underline"
                  text1="Need Help ? We are just a click away"
                  text2=""
                  subText="Contact us"
                  hasHyperLink={true}
                  hyperLink="https://www.zetran.com/contact-us/"
                ></HighlightText>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-12 d-lg-flex d-block align-items-center">
            <div className="mx-auto mx-lg-0 interaction-card">
              <div className="d-flex flex-wrap justify-content-center">
                <img
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myBooks_logo_Black.png"
                  alt=""
                  className="logo-image"
                />
              </div>
              {step === 1 && (
                <>
                  <div className="font-20-600 d-lg-none b-block my-3">
                    Few more details before launch
                  </div>
                  <label className="label mt-3">Your Business Name</label>
                  <TextFieldWithIcon
                    className={`${businessName !== "" ? "value-entered" : ""}`}
                    placeholder="John Furnitures"
                    icon={
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_67_66)">
                          <path
                            className="business-name"
                            d="M24 9.99996C24 9.92696 23.992 9.85419 23.976 9.78296L22.676 3.91496C22.4345 2.8012 21.8173 1.80434 20.9281 1.09154C20.0389 0.378743 18.9316 -0.00665845 17.792 -3.81815e-05H6.208C5.06905 -0.00573848 3.96273 0.380084 3.07433 1.09281C2.18593 1.80553 1.5694 2.80187 1.328 3.91496L0.0240014 9.78296C0.00800947 9.85419 -3.96599e-05 9.92696 1.3694e-06 9.99996V11C-0.000805438 11.9736 0.354923 12.9137 1 13.643V19C1.00159 20.3256 1.52888 21.5964 2.46622 22.5337C3.40356 23.4711 4.67441 23.9984 6 24H18C19.3256 23.9984 20.5964 23.4711 21.5338 22.5337C22.4711 21.5964 22.9984 20.3256 23 19V13.643C23.6451 12.9137 24.0008 11.9736 24 11V9.99996ZM2 10.109L3.28 4.34896C3.42504 3.68121 3.79502 3.08354 4.32801 2.65594C4.86101 2.22834 5.52469 1.99676 6.208 1.99996H7V4.99996C7 5.26518 7.10536 5.51953 7.29289 5.70707C7.48043 5.8946 7.73478 5.99996 8 5.99996C8.26522 5.99996 8.51957 5.8946 8.70711 5.70707C8.89464 5.51953 9 5.26518 9 4.99996V1.99996H15V4.99996C15 5.26518 15.1054 5.51953 15.2929 5.70707C15.4804 5.8946 15.7348 5.99996 16 5.99996C16.2652 5.99996 16.5196 5.8946 16.7071 5.70707C16.8946 5.51953 17 5.26518 17 4.99996V1.99996H17.792C18.4753 1.99676 19.139 2.22834 19.672 2.65594C20.205 3.08354 20.575 3.68121 20.72 4.34896L22 10.109V11C22 11.5304 21.7893 12.0391 21.4142 12.4142C21.0391 12.7892 20.5304 13 20 13H19C18.4696 13 17.9609 12.7892 17.5858 12.4142C17.2107 12.0391 17 11.5304 17 11C17 10.7347 16.8946 10.4804 16.7071 10.2929C16.5196 10.1053 16.2652 9.99996 16 9.99996C15.7348 9.99996 15.4804 10.1053 15.2929 10.2929C15.1054 10.4804 15 10.7347 15 11C15 11.5304 14.7893 12.0391 14.4142 12.4142C14.0391 12.7892 13.5304 13 13 13H11C10.4696 13 9.96086 12.7892 9.58579 12.4142C9.21072 12.0391 9 11.5304 9 11C9 10.7347 8.89464 10.4804 8.70711 10.2929C8.51957 10.1053 8.26522 9.99996 8 9.99996C7.73478 9.99996 7.48043 10.1053 7.29289 10.2929C7.10536 10.4804 7 10.7347 7 11C7 11.5304 6.78929 12.0391 6.41422 12.4142C6.03914 12.7892 5.53043 13 5 13H4C3.46957 13 2.96086 12.7892 2.58579 12.4142C2.21072 12.0391 2 11.5304 2 11V10.109ZM18 22H6C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19V14.873C3.3266 14.9575 3.66263 15.0002 4 15H5C5.56782 15.0003 6.12916 14.8794 6.64651 14.6453C7.16386 14.4113 7.6253 14.0696 8 13.643C8.3747 14.0696 8.83615 14.4113 9.3535 14.6453C9.87085 14.8794 10.4322 15.0003 11 15H13C13.5678 15.0003 14.1292 14.8794 14.6465 14.6453C15.1639 14.4113 15.6253 14.0696 16 13.643C16.3747 14.0696 16.8361 14.4113 17.3535 14.6453C17.8708 14.8794 18.4322 15.0003 19 15H20C20.3374 15.0002 20.6734 14.9575 21 14.873V19C21 19.7956 20.6839 20.5587 20.1213 21.1213C19.5587 21.6839 18.7957 22 18 22Z"
                            fill="rgba(0,0,0,0.57)"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_67_66">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    }
                    value={businessName}
                    onChange={businessNameChangeHandler}
                  ></TextFieldWithIcon>
                  {showBusinessNameLabel && (
                    <label className="result-label">
                      *Business Name is required.
                    </label>
                  )}
                  <label className="label mt-3">Your Business Type</label>

                  <Dropdown
                    className={`${businessType !== "" ? "value-entered" : ""}`}
                    placeholder="Eg. Retail Shop"
                    search
                    selection
                    // fluid
                    // multiple
                    value={businessType}
                    options={industry_options}
                    onChange={onSelectBusinessTypeDropDownHandler}
                    icon={{
                      className:
                        "bi bi-chevron-down absolute-position dropdown-icon-padding",
                    }}
                  />
                  {showBusinessTypeLabel && (
                    <label className="result-label">
                      *Business Type is required.
                    </label>
                  )}
                  {showAllTextFields && (
                    <>
                      <label className="label mt-3">Country</label>
                      <Dropdown
                        className={`${country !== "" ? "value-entered" : ""}`}
                        placeholder="Country"
                        search
                        selection
                        value={country}
                        options={country_options}
                        onChange={onSelectCountryDropDownHandler}
                        icon={{
                          className:
                            "bi bi-chevron-down absolute-position dropdown-icon-padding",
                        }}
                      />
                      {showCountryLabel && (
                        <label className="result-label">
                          *Country is required.
                        </label>
                      )}
                      <label className="label mt-3">Currency</label>
                      <Dropdown
                        className={`${currency !== "" ? "value-entered" : ""}`}
                        placeholder="Select your Currency"
                        search
                        selection
                        value={currency}
                        options={currency_options}
                        onChange={onSelectCurrencyDropDownHandler}
                        icon={{
                          className:
                            "bi bi-chevron-down absolute-position dropdown-icon-padding",
                        }}
                      />
                      {showCurrencyLabel && (
                        <label className="result-label">
                          *Currency is required.
                        </label>
                      )}
                      <label className="label mt-3">Financial Year</label>
                      <Dropdown
                        className={`${
                          financialYear !== "" ? "value-entered" : ""
                        }`}
                        placeholder="Financial Year"
                        search
                        selection
                        value={financialYear}
                        options={fiscal_year_options}
                        onChange={onSelectFinancialYearDropDownHandler}
                        icon={{
                          className:
                            "bi bi-chevron-down absolute-position dropdown-icon-padding",
                        }}
                      />
                      {showFinancialYearLabel && (
                        <label className="result-label">
                          *Financial Year is required.
                        </label>
                      )}
                    </>
                  )}
                  {!showAllTextFields && (
                    <>
                      <div
                        className="font-12-400 my-2 text-align-left"
                        style={{ color: "rgba(0, 0, 0, 0.4)" }}
                      >
                        We configure your myBooks based on your business type
                      </div>
                      <div className="auto-detection-country-card d-flex flex-column flex-wrap align-items-start">
                        <div className="text-align-left">
                          We have identified your country as{" "}
                          <div className="d-inline-block blue text-decoration-underline">
                            {country}
                          </div>
                          , your base currency as{" "}
                          <div className="d-inline-block blue text-decoration-underline">
                            {currency}
                          </div>
                          .
                        </div>
                        <button
                          onClick={() => {
                            setShowAllTextFields(true);
                          }}
                          className="clean-button font-12-400 blue text-decoration-underline mt-1"
                        >
                          Click to Change
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
              {step === 2 && (
                <>
                  <div className="font-20-600 mt-4 mb-3 text-align-left">
                    Adding Features
                  </div>
                  <div id="preparing-sign-up-loaders-parent">
                    {[
                      "Easy Invoicing",
                      "Expense Management",
                      "Simple Business Transactions",
                      "Bank Reconciliation",
                      "Customizable Print Templates",
                      "Insightful Business Reports",
                    ].map((name, index) => {
                      return (
                        <div
                          key={index}
                          id={index}
                          className="d-flex align-items-center justify-content-between preparing-sign-up-loaders my-3"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7.6701 2H16.3401C19.7301 2 22.0001 4.38 22.0001 7.92V16.091C22.0001 19.62 19.7301 22 16.3401 22H7.6701C4.2801 22 2.0001 19.62 2.0001 16.091V7.92C2.0001 4.38 4.2801 2 7.6701 2ZM11.4301 14.99L16.1801 10.24C16.5201 9.9 16.5201 9.35 16.1801 9C15.8401 8.66 15.2801 8.66 14.9401 9L10.8101 13.13L9.0601 11.38C8.7201 11.04 8.1601 11.04 7.8201 11.38C7.4801 11.72 7.4801 12.27 7.8201 12.62L10.2001 14.99C10.3701 15.16 10.5901 15.24 10.8101 15.24C11.0401 15.24 11.2601 15.16 11.4301 14.99Z"
                                fill="#10C847"
                              />
                            </g>
                          </svg>
                          <div className="feature-card-heading font-weight-normal text-align-left">
                            {name}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
              <button
                className={`button d-flex flex-wrap align-items-center justify-content-center ${
                  step === 1 ? "mt-4" : "mt-5"
                }`}
                onClick={ContinueToStep2}
              >
                {step === 1 && (
                  <>
                    <div className="mr-2">Get Started</div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Outline"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path
                        fill="#fff"
                        d="M18,12h0a2,2,0,0,0-.59-1.4l-4.29-4.3a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15,11H5a1,1,0,0,0,0,2H15l-3.29,3.29a1,1,0,0,0,1.41,1.42l4.29-4.3A2,2,0,0,0,18,12Z"
                      />
                    </svg>
                  </>
                )}
                {step === 2 && (
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="spinner-border" role="status"></div>
                    <div className="mx-4">
                      Please Wait... It may take a while
                    </div>
                  </div>
                )}
              </button>
              {step === 1 && props.failMessage !== "" && (
                <label className="result-label">
                  {props.failMessage ===
                  "Phone number based signup is not allowed for other countries"
                    ? "Phone number based signup is currently available for India only."
                    : props.failMessage}
                </label>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessDetailsWiz;
